import { ReportSubscriptionTypesEnum } from '../../enum/report-subscription-types.enum';
import { ScheduleTypeEnum } from '../../enum/schedule-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ContractContactData {
  ContractContactId: string;
  ContactName: string;
  EmailAddress: string;
  PhoneNumber: string;
  IsInactive: boolean;
  ReportSubscriptionTypes: ReportSubscriptionTypesEnum;
  ScheduledReportStartDate: string;
  CreatedOn: string;
  ModifiedOn: string;
  ScheduleType: ScheduleTypeEnum;
  ContactTypeId: string;
}


